module.exports = __webpack_public_path__ + "static/img/2.63363af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital0/2.png
// module id = cjtO
// module chunks = 1